import { connect } from 'react-redux';
import { AnyAction, bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage } from 'react-intl';
import { authSlice } from 'features/auth/authSlice';


const RegAlreadyLoggedIn = (props: Props) => {
    return (
        <div id="screen-already-logged-in">
            <div className="panel radius-rectangle full-width-form">
                <div className="panel-header">
                    <h1 className="bold-title">
                        <FormattedMessage id="ALREADY_LOGGED_IN_TITLE" />
                    </h1>
                </div>
                <div className="panel-content">
                    <p className="text-light">
                        <FormattedMessage id="ALREADY_LOGGED_IN_TEXT" />
                    </p>
                    <button type="button" onClick={props.logout} className="btn-blue btn-with-arrow">
                        <FormattedMessage id="GLOBAL_LOGOUT" />
                    </button>
                </div>
            </div>
        </div>
    );
};

type Props = DispatchProps;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators(
        {
            logout: authSlice.actions.logout,
        },
        dispatch
    );
}

export default connect(null, mapDispatchToProps)(RegAlreadyLoggedIn);